import axios from "axios";

const { REACT_APP_ENDPOINT } = process.env;
const ENDPOINT = `${REACT_APP_ENDPOINT}/api/novedades/`;

export default class novedades {
  static async getNovedadesByClienteId(clienteId, contactoId) {
    const respuesta = await axios
      .get(`${ENDPOINT}getNovedades/${clienteId}/${contactoId}`)
      .then((response) => {
        return response;
      });
    return respuesta.data;
  }

  static async getNovedadesMenuByClienteId(clienteId, contactoId) {
    const respuesta = await axios
      .get(`${ENDPOINT}getNovedadesMenu/${clienteId}/${contactoId}`)
      .then((response) => {
        return response;
      });
    return respuesta.data;
  }

  static async marcarNovedadComoLeida({ clienteId, contactoId, novedadId }) {
    const respuesta = await axios
      .post(`${ENDPOINT}marcarNovedadLeida`, {
        clienteId,
        contactoId,
        novedadId,
      })
      .then((response) => {
        return response;
      });
    return respuesta.data;
  }
}
